import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: ${props=>props.withTimeline ? `repeat(4, 1fr)`: `1fr`};
  grid-template-rows: 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 0px;
`;

export const Left = styled.div`
  grid-area: 1 / 1 / 2 / 4;
`;

export const Right = styled.div`
  grid-area: 1 / 4 / 2 / 5;
`;
